<script>
    import {colors} from './stores.js';
    import { spring } from 'svelte/motion';

    let segmentColors = [
        $colors.red[700],
        $colors.red[600],
        $colors.red[500],
        $colors.yellow[500],
        $colors.green[500],
        $colors.green[600],
        $colors.green[700],
    ];
    $: segmentPaths = segmentColors.map((color, index, array) => {
        let points = [
            {
                x: 5 + 4 * Math.cos((index * Math.PI / array.length) + Math.PI / 50),
                y: 5 - 4 * Math.sin((index * Math.PI / array.length) + Math.PI / 50)
            },
            {
                x: 5 + 4.75 * Math.cos((index * Math.PI / array.length) + Math.PI / 50),
                y: 5 - 4.75 * Math.sin((index * Math.PI / array.length) + Math.PI / 50)
            },
            {
                x: 5 + 4.75 * Math.cos(((index + 1) * Math.PI / array.length) - Math.PI / 50),
                y: 5 - 4.75 * Math.sin(((index + 1) * Math.PI / array.length) - Math.PI / 50)
            },
            {
                x: 5 + 4 * Math.cos(((index + 1) * Math.PI / array.length) - Math.PI / 50),
                y: 5 - 4 * Math.sin(((index + 1) * Math.PI / array.length) - Math.PI / 50)
            }
        ];
        return `M ${points[0].x} ${points[0].y} L ${points[1].x} ${points[1].y} ` +
            `A 4.75 4.75 0 0 0 ${points[2].x} ${points[2].y} L ${points[3].x} ${points[3].y} ` +
            `A 4 4 0 0 1 ${points[0].x} ${points[0].y}`;
    });
    let selectedSegment = 3;
    let arrowAngle = spring(calculateArrowAngle(selectedSegment), {
		stiffness: 0.1,
		damping: 0.25
    });

    $: if (selectedSegment >= 0) {
         arrowAngle.set(calculateArrowAngle(selectedSegment));
    }

    function calculateArrowAngle (index) {
        let segmentSize = 180 / segmentColors.length;
        return  -1 * segmentSize * (index + 1) + segmentSize / 2;
    }
</script>

<svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full p-4" viewBox="0 0 10 5">
    <path d="M 0 5 a 5 5 0 0 1 10 0 z" fill="{$colors.gray[800]}" />
    {#each segmentPaths as path, index}
        <path d="{path}" fill="{segmentColors[index]}" on:click={() => selectedSegment = index} />
    {/each}
    <g transform="rotate({$arrowAngle}, 5, 5)">
        <line x1="5.9" y1="5" x2="9" y2="5" stroke="{$colors.gray[900]}" stroke-width="0.25" />
        <path d="M 8.5 5 l 0 -.5 l 1 0.5 l -1 0.5 z" fill="{$colors.gray[900]}" />
    </g>
    <path d="M 4 5 a 1 1 0 0 1 2 0 z" fill="{$colors.gray[900]}" />
</svg>
